'use client';

import { c as _c } from "react/compiler-runtime";
import { cn } from '@core/utils';
import { cva } from 'class-variance-authority';
import React, { forwardRef, useState } from 'react';
import SvgAdd from '../../../__generated__/icon/SvgAdd';
import SvgLogo from '../../../__generated__/icon/SvgLogo';
import SvgWelloBizLogo from '../../../__generated__/icon/SvgWelloBizLogo';
type AvatarSize = 24 | 32 | 40 | 48 | 56 | 64 | 80;
type AvatarType = 'person' | 'company' | 'wello' | 'wellobiz';
interface BaseAvatarProps {
  size?: AvatarSize;
  type?: AvatarType;
  className?: string;
}
interface AvatarCoreProps extends BaseAvatarProps {
  type: AvatarType;
  src?: string;
  alt: string;
}
interface AvatarProps extends BaseAvatarProps {
  showMore?: boolean;
  src?: string | string[];
  alt?: string | string[];
  name?: string;
}
const PersonSvg = () => {
  const $ = _c(2);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <g clipPath="url(#clip0_6090_25174)"><path clipRule="evenodd" d="M108 54C108 68.4787 102.301 81.6264 93.0258 91.3233C83.2287 101.564 69.4417 107.955 54.1612 108H54H53.8388C38.5583 107.955 24.771 101.564 14.9744 91.3233C5.69823 81.6264 0 68.4787 0 54C0 24.1766 24.1766 0 54 0C83.8234 0 108 24.1766 108 54ZM86.7302 81C78.9488 71.5768 67.1755 65.5712 54 65.5712C40.8245 65.5712 29.0515 71.5768 21.2694 81C29.0515 90.423 40.8245 96.4286 54 96.4286C67.1755 96.4286 78.9488 90.423 86.7302 81ZM54.0009 57.8569C64.6521 57.8569 73.2866 49.2224 73.2866 38.5712C73.2866 27.92 64.6521 19.2855 54.0009 19.2855C43.3497 19.2855 34.7152 27.92 34.7152 38.5712C34.7152 49.2224 43.3497 57.8569 54.0009 57.8569Z" fill="currentColor" fillRule="evenodd" /></g>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <svg className="text-Gray-300" fill="none" height="108" viewBox="0 0 108 108" width="108" xmlns="http://www.w3.org/2000/svg">{t0}<defs><clipPath id="clip0_6090_25174"><rect fill="white" height="108" width="108" /></clipPath></defs></svg>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};
const CompanySvg = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <svg className="text-Gray-300" fill="none" height="112" viewBox="0 0 112 112" width="112" xmlns="http://www.w3.org/2000/svg"><path d="M0 16C0 7.16344 7.16344 0 16 0H96C104.837 0 112 7.16344 112 16V96C112 104.837 104.837 112 96 112H16C7.16344 112 0 104.837 0 96V16Z" fill="currentColor" /><path clipRule="evenodd" d="M29.8206 34.6249V77.3745H59.6512V34.6249H29.8206ZM27.0063 29H62.4654C64.0197 29 65.2796 30.2592 65.2796 31.8125V80.187C65.2796 81.7403 64.0196 82.9995 62.4654 82.9995H27.0063C25.4521 82.9995 24.1921 81.7403 24.1921 80.187V31.8125C24.1921 30.2592 25.4521 29 27.0063 29Z" fill="white" fillRule="evenodd" /><path clipRule="evenodd" d="M60.214 49.3428C60.214 47.7896 61.474 46.5304 63.0282 46.5304H84.457C86.0112 46.5304 87.2712 47.7896 87.2712 49.3428V80.072C87.2712 81.6253 86.0112 82.8845 84.457 82.8845H62.3453C60.7911 82.8845 59.5311 81.6253 59.5311 80.072C59.5311 78.5187 60.7911 77.2596 62.3453 77.2596H81.6427V52.1553H63.0282C61.474 52.1553 60.214 50.8961 60.214 49.3428Z" fill="white" fillRule="evenodd" /><path clipRule="evenodd" d="M44.6548 68.4739C46.209 68.4739 47.469 69.7331 47.469 71.2864V80.0661C47.469 81.6194 46.209 82.8786 44.6548 82.8786C43.1006 82.8786 41.8406 81.6194 41.8406 80.0661V71.2864C41.8406 69.7331 43.1006 68.4739 44.6548 68.4739Z" fill="white" fillRule="evenodd" /><path clipRule="evenodd" d="M35.2077 58.6826C35.2077 57.1294 36.4676 55.8702 38.0219 55.8702H51.2889C52.8431 55.8702 54.1031 57.1294 54.1031 58.6826C54.1031 60.2359 52.8431 61.4951 51.2889 61.4951H38.0219C36.4676 61.4951 35.2077 60.2359 35.2077 58.6826Z" fill="white" fillRule="evenodd" /><path clipRule="evenodd" d="M35.2077 45.5163C35.2077 43.9631 36.4676 42.7039 38.0219 42.7039H51.2889C52.8431 42.7039 54.1031 43.9631 54.1031 45.5163C54.1031 47.0696 52.8431 48.3288 51.2889 48.3288H38.0219C36.4676 48.3288 35.2077 47.0696 35.2077 45.5163Z" fill="white" fillRule="evenodd" /></svg>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
const defaultImages: Record<AvatarType, () => React.JSX.Element> = {
  person: () => <PersonSvg />,
  company: () => <CompanySvg />,
  wello: () => <SvgLogo />,
  wellobiz: () => <SvgWelloBizLogo />
};
const avatarVariants = cva("relative overflow-hidden bg-Gray-white flex-center after:pointer-events-none after:absolute after:inset-0 after:rounded-[inherit] after:ring-1 after:ring-inset after:ring-Gray-black/5 after:content-['']", {
  variants: {
    type: {
      person: 'rounded-pill',
      wello: 'rounded-pill',
      wellobiz: 'rounded-pill',
      company: 'rounded-xxsmall'
    }
  },
  defaultVariants: {
    type: 'person'
  }
});
const OVERLAP_OFFSET_RATIO = 1.4;
const AvatarCore = forwardRef<HTMLDivElement, AvatarCoreProps>((t0, ref) => {
  const $ = _c(33);
  const {
    size,
    type,
    alt,
    src,
    className
  } = t0;
  const [hasError, setHasError] = useState(false);
  const DefaultIcon = defaultImages[type];
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      setHasError(true);
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const handleError = t1;
  if (hasError) {
    let t2;
    if ($[1] !== className || $[2] !== type) {
      t2 = cn(avatarVariants({
        type
      }), className);
      $[1] = className;
      $[2] = type;
      $[3] = t2;
    } else {
      t2 = $[3];
    }
    let t3;
    if ($[4] !== size) {
      t3 = {
        width: size,
        height: size,
        minWidth: size,
        minHeight: size
      };
      $[4] = size;
      $[5] = t3;
    } else {
      t3 = $[5];
    }
    const t4 = alt ? "img" : undefined;
    const t5 = alt || undefined;
    const t6 = alt ? undefined : true;
    let t7;
    if ($[6] !== DefaultIcon) {
      t7 = <DefaultIcon />;
      $[6] = DefaultIcon;
      $[7] = t7;
    } else {
      t7 = $[7];
    }
    let t8;
    if ($[8] !== ref || $[9] !== t2 || $[10] !== t3 || $[11] !== t4 || $[12] !== t5 || $[13] !== t6 || $[14] !== t7) {
      t8 = <div ref={ref} className={t2} style={t3} role={t4} aria-label={t5} aria-hidden={t6}>{t7}</div>;
      $[8] = ref;
      $[9] = t2;
      $[10] = t3;
      $[11] = t4;
      $[12] = t5;
      $[13] = t6;
      $[14] = t7;
      $[15] = t8;
    } else {
      t8 = $[15];
    }
    return t8;
  }
  let t2;
  if ($[16] !== className || $[17] !== type) {
    t2 = cn(avatarVariants({
      type
    }), className);
    $[16] = className;
    $[17] = type;
    $[18] = t2;
  } else {
    t2 = $[18];
  }
  let t3;
  if ($[19] !== size) {
    t3 = {
      width: size,
      height: size,
      minWidth: size,
      minHeight: size
    };
    $[19] = size;
    $[20] = t3;
  } else {
    t3 = $[20];
  }
  const t4 = !src && alt ? "img" : undefined;
  const t5 = !src && alt ? alt : undefined;
  const t6 = !src && !alt ? true : undefined;
  let t7;
  if ($[21] !== DefaultIcon || $[22] !== alt || $[23] !== src) {
    t7 = src ? <img alt={alt} className={cn("absolute inset-0 size-full object-cover", "user-none-drag")} src={src} onError={handleError} /> : <DefaultIcon />;
    $[21] = DefaultIcon;
    $[22] = alt;
    $[23] = src;
    $[24] = t7;
  } else {
    t7 = $[24];
  }
  let t8;
  if ($[25] !== ref || $[26] !== t2 || $[27] !== t3 || $[28] !== t4 || $[29] !== t5 || $[30] !== t6 || $[31] !== t7) {
    t8 = <div ref={ref} className={t2} style={t3} role={t4} aria-label={t5} aria-hidden={t6}>{t7}</div>;
    $[25] = ref;
    $[26] = t2;
    $[27] = t3;
    $[28] = t4;
    $[29] = t5;
    $[30] = t6;
    $[31] = t7;
    $[32] = t8;
  } else {
    t8 = $[32];
  }
  return t8;
});
AvatarCore.displayName = 'AvatarCore';
export const Avatar = forwardRef<HTMLDivElement, AvatarProps>((t0, ref) => {
  const $ = _c(37);
  const {
    size: t1,
    type: t2,
    alt,
    src,
    className,
    name,
    showMore: t3
  } = t0;
  const size = t1 === undefined ? 32 : t1;
  const type = t2 === undefined ? "person" : t2;
  const showMore = t3 === undefined ? false : t3;
  const isMulti = Array.isArray(src);
  const overlapOffset = Math.round(size / OVERLAP_OFFSET_RATIO);
  const nonOverlapSize = size - overlapOffset;
  let t4;
  if ($[0] !== isMulti || $[1] !== src) {
    t4 = isMulti ? src as string[] : [src];
    $[0] = isMulti;
    $[1] = src;
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  const multiSrc = t4;
  let t5;
  if ($[3] !== alt || $[4] !== multiSrc) {
    t5 = Array.isArray(alt) ? alt : multiSrc.map(_temp);
    $[3] = alt;
    $[4] = multiSrc;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  const multiAlt = t5;
  const singleAlt = Array.isArray(alt) ? alt[0] : alt ?? "avatar";
  if (!isMulti) {
    let t6;
    if ($[6] !== className || $[7] !== ref || $[8] !== singleAlt || $[9] !== size || $[10] !== src || $[11] !== type) {
      t6 = <AvatarCore ref={ref} alt={singleAlt} className={className} size={size} src={src} type={type} />;
      $[6] = className;
      $[7] = ref;
      $[8] = singleAlt;
      $[9] = size;
      $[10] = src;
      $[11] = type;
      $[12] = t6;
    } else {
      t6 = $[12];
    }
    return t6;
  }
  let t6;
  if ($[13] !== className) {
    t6 = cn("flex items-center", className);
    $[13] = className;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== multiAlt || $[16] !== multiSrc || $[17] !== name || $[18] !== nonOverlapSize || $[19] !== size || $[20] !== type) {
    let t8;
    if ($[22] !== multiAlt || $[23] !== name || $[24] !== nonOverlapSize || $[25] !== size || $[26] !== type) {
      t8 = (avatarSrc, index) => <div key={`${name ? `${name}-` : ""}${avatarSrc}-${index}`} style={{
        marginLeft: index ? -nonOverlapSize : 0
      }}><AvatarCore alt={multiAlt[index]} className="border-1 border-Gray-white" size={size} src={avatarSrc} type={type} /></div>;
      $[22] = multiAlt;
      $[23] = name;
      $[24] = nonOverlapSize;
      $[25] = size;
      $[26] = type;
      $[27] = t8;
    } else {
      t8 = $[27];
    }
    t7 = multiSrc.map(t8);
    $[15] = multiAlt;
    $[16] = multiSrc;
    $[17] = name;
    $[18] = nonOverlapSize;
    $[19] = size;
    $[20] = type;
    $[21] = t7;
  } else {
    t7 = $[21];
  }
  let t8;
  if ($[28] !== nonOverlapSize || $[29] !== showMore || $[30] !== size) {
    t8 = showMore ? <div className="relative rounded-pill border-1 border-Gray-white bg-Gray-300 flex-center" role="img" aria-label={"\uCD94\uAC00 \uC544\uBC14\uD0C0"} style={{
      marginLeft: -nonOverlapSize,
      width: size,
      height: size
    }}><SvgAdd aria-hidden={true} className="size-8 text-Gray-600" /></div> : null;
    $[28] = nonOverlapSize;
    $[29] = showMore;
    $[30] = size;
    $[31] = t8;
  } else {
    t8 = $[31];
  }
  let t9;
  if ($[32] !== ref || $[33] !== t6 || $[34] !== t7 || $[35] !== t8) {
    t9 = <div ref={ref} className={t6}>{t7}{t8}</div>;
    $[32] = ref;
    $[33] = t6;
    $[34] = t7;
    $[35] = t8;
    $[36] = t9;
  } else {
    t9 = $[36];
  }
  return t9;
});
Avatar.displayName = 'Avatar';
function _temp() {
  return "avatar";
}